//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 05/08/2024
// Version : 1
// Description : tabla de reclamos por motivos (motivos de los casos)
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useEffect, useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { styled } from "@mui/system";
import IconButton from "@mui/material/IconButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import dayjs from "dayjs";
import useMediaQuery from "@mui/material/useMediaQuery";

function Tabla_categorias(props) {
  const [cantidadXcategoria, setCantidadXcategoria] = useState([]);
  const [idElegido, setIdElegido] = useState(null);
  const { selectedDate } = props;
  const isMobile = useMediaQuery("(max-width:600px)");

  const obtenerCantidadXcategoria = () => {
    const formattedDate = selectedDate.format("YYYY"); // Formatear la fecha seleccionada
    fetch(UrlApi + "/reclamos/cantidadPorCategoria/fecha/" + formattedDate)
      .then((data) => data.json())
      .then((data) => setCantidadXcategoria(data));
  };
  useEffect(() => {
    obtenerCantidadXcategoria();
  }, [selectedDate]);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  // Ordenar los datos de mayor a menor por cantidad de reclamos
  const cantidadXcategoriaOrdenado = [...cantidadXcategoria].sort(
    (a, b) => b.cantidad_reclamos - a.cantidad_reclamos
  );

  // Calcular el total de reclamos
  const totalReclamos = cantidadXcategoriaOrdenado.reduce(
    (total, item) => total + item.cantidad_reclamos,
    0
  );

  // Transformar los datos para el PieChart, incluyendo el porcentaje
  const data = (cantidadXcategoriaOrdenado || []).map((item) => ({
    label: `${item.categoria} (${(
      (item.cantidad_reclamos / totalReclamos) *
      100
    ).toFixed(2)}%)`,
    value: item.cantidad_reclamos,
  }));

  const data2 = (cantidadXcategoriaOrdenado || []).map((item) => ({
    categoria: item.categoria,
    cantidad: item.cantidad_reclamos,
    porcentaje: ((item.cantidad_reclamos / totalReclamos) * 100).toFixed(2), // Calcular el porcentaje
  }));

  const HeaderCell = styled(TableCell)({
    marginTop: "2px",
    fontSize: 13,
    color: "white",
    fontWeight: "normal",
    backgroundColor: "#2471A3",
    borderColor: "white",
    padding: "7px",
  });

  return (
    <div>
      <Paper
        elevation={10}
        style={{
          padding: isMobile ? "8px" : "10px",
          width: "100%",
          height: "100%",
          margin: "0 auto",
          display: "flex", // 👈 permite que el contenido se ajuste
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: 10,
          }}
        >
          <Typography
            align="center"
            style={{
              fontWeight: "bold",
              fontSize: isMobile ? 18 : 20, // título más chico en mobile
            }}
          >
            Categorías
          </Typography>
        </div>
        <TableContainer style={{ maxHeight: isMobile ? "50vh" : "100vh" }}>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <HeaderCell align="center" sx={{ border: "1px solid black" }}>
                  <b>Categoría</b>
                </HeaderCell>
                <TableCell
                  align="center"
                  style={{
                    backgroundColor: "#2B76A6",
                    color: "white",
                    border: "1px solid black",
                  }}
                >
                  <b>Cantidad</b>
                </TableCell>
                <HeaderCell
                  align="center"
                  style={{
                    backgroundColor: "#2B76A6",
                    color: "white",
                    border: "1px solid black",
                    padding: "10px",
                  }}
                >
                  <b>Porcentaje</b>
                </HeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data2.map((row, index) => (
                <TableRow key={index} sx={{ border: "1px solid black" }}>
                  <TableCell
                    sx={{ border: "1px solid black", padding: "25px" }}
                  >
                    {row.categoria}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ border: "1px solid black", padding: "25px" }}
                  >
                    {row.cantidad}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ border: "1px solid black", padding: "25px" }}
                  >
                    {row.porcentaje}%
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}

export default Tabla_categorias;
